<div id="View_cat_main">
<div class="pre-loader" *ngIf="loading">
  <div class="load-icon">
    <div class="ring-load">
      <div class="circle"></div>
      <div class="pageload-icon"></div>
    </div>
  </div>
</div>

<div class="ox_hidden" id="Cemex_incidendes_id">

  <div class="lb-head-single row no-m">
    <div class="col-3">
      <h6 class="d-inline">Area <span class="color_black">North </span></h6>
    </div>
    <div class="col-3">
      <h6 class="d-inline">Category <span class="color_black">RTC </span></h6>
    </div>
    <div class="col-3">
      <h6 class="d-inline">VRN <span class="color_black">FN17BWB </span></h6>
    </div>
    <div class="col-3 icon_case text-right">
      <i class="color_gray fas fa-copy font_20 mr-2" title=""></i>

      <i class="color_gray fas fa-hand-scissors  font_20 mr-2"></i>

      <i data-toggle="modal" data-target="#Share_Case" tooltip="Share" placement="left" class="fleetly_color mr-2 fas fa-share font_20"></i>

      <i class="color_gray fas fa-times-circle  font_20 "  (click)="backToCategories()" tooltip="Close"></i>
    </div>




  </div>
  <div class="row m-0">

    <div class="col-lg-9 bod_left pr-0 pl-0">

      <div class="card-scroll p-0" style="height: calc(100vh - 25px);">
        <div class="row no-m">
          <div class="col-6 pl-05 pr-05">
            <img class="width_100pc" src="../../../assets/images/test_map1.png" />
          </div>
          <div class="col-6 pl-0 pr-05">
            <img class="width_100pc" src="../../../assets/images/test_video.png" />
          </div>
        </div>
        <div class="mt-0 p-1">
          <div id="#filers_toggle_section">
            <div class="filers_toggle_hearder">
              <a class="row no-m" data-toggle="collapse" href="#coll" aria-expanded="true">
                <div class="col-11 p-0">
                  <h6 class="text-white"> Files</h6>
                </div>
                <div class="col-1 text-right">
                  <span class="file_count_style"> 16</span>
                </div>
                <!-- <span class="collapsed"><i class="fal fa-arrow-circle-down font_20 text-white"></i></span>
              <span class="expanded"><i class="fal fa-arrow-circle-down font_20 text-white"></i></span>-->
              </a>
            </div>
            <div class="collapse show carder ml-0" id="coll">
              <div class="row no-m">
                <div class="col-md-4 pl-0">
                  <div class="file_child">
                    <div class="row no-m">
                      <div class="col-md-9 pl-0">
                        <div class="row no-m">
                          <div class="col-md-12 pl-0">
                            <span class="file_child_i"> <i class="fas fa-images"></i> </span>
                            <span class="file_child_name"> IMG_10000 </span>
                          </div>
                          <div class="col-md-12 pl-0 mt-1">

                            <span class="file_child_file"> PNG File </span>
                            <span class="file_child_size"> 21 MB </span>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3 pl-0">
                        <span class="file_child_share"> <i data-toggle="modal" data-target="#Share_Case" class="cursor-pointer fa fa-share font_16"></i> </span>
                        <span class="file_child_view pull-right"> <i class="font_16 fas fa-download"></i> </span>
                      </div>
                    </div>



                  </div>
                </div>

                <div class="col-md-4 pl-0">
                  <div class="file_child">
                    <div class="row no-m">
                      <div class="col-md-9 pl-0">
                        <div class="row no-m">
                          <div class="col-md-12 pl-0">
                            <span class="file_child_i"> <i class="fas fa-video"></i> </span>
                            <span class="file_child_name">Video_10000 </span>
                          </div>
                          <div class="col-md-12 pl-0 mt-1">

                            <span class="file_child_file"> MP3 File </span>
                            <span class="file_child_size"> 21 MB </span>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3 pl-0">
                        <span class="file_child_share"> <i data-toggle="modal" data-target="#Share_Case" class="cursor-pointer fa fa-share font_16"></i> </span>
                        <span class="file_child_view pull-right"> <i class="font_16 fas fa-download"></i> </span>
                      </div>
                    </div>



                  </div>
                </div>

                <div class="col-md-4 pl-0">
                  <div class="file_child">
                    <div class="row no-m">
                      <div class="col-md-9 pl-0">
                        <div class="row no-m">
                          <div class="col-md-12 pl-0">
                            <span class="file_child_i"> <i class="fas fa-file-pdf"></i> </span>
                            <span class="file_child_name"> PDF_10000 </span>
                          </div>
                          <div class="col-md-12 pl-0 mt-1">
                            <span class="file_child_file"> PNG File </span>
                            <span class="file_child_size"> 21 MB </span>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3 pl-0">
                        <span class="file_child_share"> <i data-toggle="modal" data-target="#Share_Case" class="cursor-pointer fa fa-share font_16"></i> </span>
                        <span class="file_child_view pull-right"> <i class="font_16 fas fa-download"></i> </span>
                      </div>
                    </div>



                  </div>
                </div>


                <div class="col-md-4 pl-0">
                  <div class="file_child">
                    <div class="row no-m">
                      <div class="col-md-9 pl-0">
                        <div class="row no-m">
                          <div class="col-md-12 pl-0">
                            <span class="file_child_i"> <i class="fas fa-file-pdf"></i> </span>
                            <span class="file_child_name"> PDF_10000 </span>
                          </div>
                          <div class="col-md-12 pl-0 mt-1">
                            <span class="file_child_file"> PNG File </span>
                            <span class="file_child_size"> 21 MB </span>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3 pl-0">
                        <span class="file_child_share"> <i data-toggle="modal" data-target="#Share_Case" class="cursor-pointer fa fa-share font_16"></i> </span>
                        <span class="file_child_view pull-right"> <i class="font_16 fas fa-download"></i> </span>
                      </div>
                    </div>



                  </div>
                </div>

                <div class="col-md-4 pl-0">
                  <div class="file_child">
                    <div class="row no-m">
                      <div class="col-md-9 pl-0">
                        <div class="row no-m">
                          <div class="col-md-12 pl-0">
                            <span class="file_child_i"> <i class="fas fa-file"></i> </span>
                            <span class="file_child_name"> DOC_10000 </span>
                          </div>
                          <div class="col-md-12 pl-0 mt-1">
                            <span class="file_child_file"> Word File </span>
                            <span class="file_child_size"> 21 MB </span>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3 pl-0">
                        <span class="file_child_share"> <i data-toggle="modal" data-target="#Share_Case" class="cursor-pointer fa fa-share font_16"></i> </span>
                        <span class="file_child_view pull-right"> <i class="font_16 fas fa-download"></i> </span>
                      </div>
                    </div>



                  </div>
                </div>


            
                <div class="col-md-4 text-left">
                  <i data-toggle="modal" data-target="#file_modal" tooltip="Add File" placement="left"
                     class="fleetly_color  fas fa-plus-circle font_20"></i>
                </div>

              </div>
            </div>
          </div>

        </div>
        <div class="p-1 mt-2">

          <div class="row no-m">

          </div>
          <h5 class="Heading_h5 mb-2">Audit</h5>
          <div class="Manger_comp mb-2 no-p">
            <table class="table table-striped evidence_table">
              <thead>
                <tr class="trhead">
                  <th>User</th>
                  <th class="text-center">Fleet</th>
                  <th class="text-center">Category</th>
                  <th class="text-center">Info</th>
                  <th class="text-center">Date</th>

                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Hennry Willliams</td>
                  <td>Uk Global-Fleet</td>
                  <td>Near Miss</td>
                  <td>Video Dowmload</td>
                  <td>2025-May-14 16:37:50</td>
                </tr>
                <tr>
                  <td>Dean Ambrose</td>
                  <td>US-Fleet</td>
                  <td>RTC</td>
                  <td>PDF Viewed</td>
                  <td>2025-May-14 16:37:50</td>
                </tr>
                <tr>
                  <td> Willliams</td>
                  <td>Global-Transport</td>
                  <td>Near Miss</td>
                  <td>Video Dowmload</td>
                  <td>2025-May-14 16:37:50</td>
                </tr>
                <tr>
                  <td>Hennry Willliams</td>
                  <td>Uk Global-Fleet</td>
                  <td>Near Miss</td>
                  <td>Document Dowmload</td>
                  <td>2025-May-14 16:37:50</td>
                </tr>

                <tr>
                  <td> James</td>
                  <td>Global-Transport</td>
                  <td>Training</td>
                  <td>Video Dowmload</td>
                  <td>2025-May-14 16:37:50</td>
                </tr>
                <tr>
                  <td>Roodes</td>
                  <td>LetsFleetek</td>
                  <td>RTC</td>
                  <td>File Upload</td>
                  <td>2025-May-14 16:37:50</td>
                </tr>

              </tbody>
            </table>
          </div>
        </div>
      </div>

    </div>

    <div class="col-lg-3 col-md-4 col-12 p-0 card-scroll_main">

      <div class="new_shadow mt-1">
        <div class="lb-head">
          <div class="clearfix">
            <h6 class="no-m pull-left">Details</h6>

            <!--  <i data-toggle="modal" data-target="#filters" tooltip="Filters" placement="left" class="fas fa-filter pull-right"></i>
        -->
          </div>
        </div>
        <div class="card-scroll p-1 pt-0" style="height: calc(100vh - 130px);">
          <div class="row mt-2">
            <div class="col-12 mb-1">
              <label>Fleet</label>
              <select class="form-control" name="selectFleet" [(ngModel)]="selectedFleet">
                <option value="" disabled>Select Fleet</option>
                @for(item of fleetList; track item.FleetId){
                <option [value]="item.Id" class="">{{item.Name}}</option>
                }

              </select>
              <!-- <input type="text"   class="form-control" name="fleetName" [value]="selectedFleet" placeholder="Fleet Name"  />-->
            </div>
            <div class="col-12 mb-1">
              <label>Category</label>
              <input type="text" name="name" value="" class="form-control" placeholder="Category" />
            </div>


            <div class="col-12 mb-1">
              <label>Date </label>
              <input type="text" name="name" value="" class="form-control" placeholder="Date" />
            </div>
            <div class="col-12 mb-1">
              <label>VRN </label>
              <input type="text" name="name" value="" class="form-control" placeholder="VRN" />
            </div>
            <div class="col-12 mb-1">
              <label>Driver Name </label>
              <input type="text" class="form-control" placeholder="Driver Name">
            </div>
            <div class="col-12 mb-1">
              <label>Incident No</label>
              <input type="text" class="form-control" placeholder="Incident No">
            </div>
            <div class="col-12 mb-1">
              <label>Utility</label>
              <input type="text" class="form-control" placeholder="Utility">
            </div>
            <div class="col-12 mb-1">
              <label>Driver's Action During Incident</label>
              <input type="text" class="form-control" placeholder="Actions">
            </div>
            <div class="col-12 mb-1">
              <label>Driver Type</label>
              <input type="text" class="form-control" placeholder="Driver Type">
            </div>
          </div>



        </div>
        <div class="livefoot">
          <div class="row no-m width_100pc">
            <div class="col-md-6">

            </div>
            <div class="col-md-6 text-right pr-0">
              <a class="btn btn-success">Save</a>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
<div id="file_modal" tabindex="-1" class="modal fade right" style="z-index: 1;" aria-modal="true" role="dialog">
  <div class="modal-dialog no-m" style="width: 27%;">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">Upload File</h6>
        <button type="button" data-dismiss="modal" aria-label="Close" class="close">
          <span aria-hidden="true">×</span>
        </button>
      </div>

      <form novalidate name="createreqform">
        <div class="modal-body card-scroll">

          <!-- Media Type Selection -->
          <div class="form-group">
            <label><b>Media Type </b></label>
            <div class="media-options d-flex gap-2">
              <label class="media-radio" *ngFor="let type of mediaTypes">
                <input type="radio"
                       name="mediaType"
                       [value]="type.value"
                       [(ngModel)]="selectedMediaType"
                       (change)="selectMediaType(type.value)" />
                <div class="media-content" [class.active]="selectedMediaType === type.value">
                  <i class=""  [ngClass]="type.icon"></i>
                  <span>{{ type.label }}</span>
                </div>
              </label>
            </div>
          </div>

          <!-- Upload Method: Alert ID -->
          <!-- Alert ID Section -->
          <div *ngIf="selectedMediaType == 'media'" class="form-group">
            <div class="d-flex align-items-center mb-2">
              <input type="radio" name="uploadMethod" value="alert" [(ngModel)]="selectedUploadMethod" class="me-2 mt-0" />
              <label class="mb-0"><strong>Alert ID</strong></label>
            </div>

            <div [class.disabled-section]="selectedUploadMethod !== 'alert'">
              <div class="input-group">
                <span class="input-group-text px-3" style="height:30px;">#</span>
                <input type="text"
                       class="form-control"
                       placeholder="Enter Alert Id"
                       [(ngModel)]="alertId"
                       [disabled]="selectedUploadMethod !== 'alert'" />
                <button type="button"
                        class="btn btn-outline-primary"
                        style="height:30px;"
                        (click)="fetchAlertData()"
                        [disabled]="selectedUploadMethod !== 'alert'">
                  Fetch
                </button>
              </div>
            </div>
          </div>

          <!-- OR Separator -->
          <div class="or-separator" *ngIf="selectedUploadMethod === 'alert'">
            <div class="line"></div>
            <div class="or-text">OR</div>
            <div class="line"></div>
          </div>



          <!-- Upload Method: User Request Video -->
          <div class="user_request_bod">
            <label class="d-flex align-items-center">
              <input type="radio" name="uploadMethod" value="request" [(ngModel)]="selectedUploadMethod" class="mr-05" />
              <strong> User Request Video</strong>
            </label>

            <div [class.disabled-section]="selectedUploadMethod !== 'request'" class="mt-2">
              <div class="row">
                <div class="col-md-12 mb-05">
                  <label>VRN</label>
                  <select class="form-control" [(ngModel)]="requestVRN" [disabled]="selectedUploadMethod !== 'request'">
                    <option *ngFor="let v of vrnList" [value]="v.DeviceIdentifier">{{ v.VRN }}</option>
                  </select>
                </div>
                <div class="col-md-5">
                  <label>Date</label>
                  <!--   <input type="date" class="form-control"
    [(ngModel)]="requestDate"
    [disabled]="selectedUploadMethod !== 'request'" />-->
                  <input type="text"
                         class="form-control"
                         placeholder="Select Date"
                         [(ngModel)]="requestDate"
                         [bsConfig]="bsConfig"
                         bsDatepicker
                         [disabled]="selectedUploadMethod !== 'request'" />
                </div>
                <div class="col-md-4 pl-0">
                  <label>Time</label>
                  <input type="time" class="form-control"
                         [(ngModel)]="requestTime"
                         [disabled]="selectedUploadMethod !== 'request'" />
                </div>
                <div class="col-md-3 pl-0">
                  <label style="visibility:hidden;">Request</label>
                  <div *ngIf="selectedUploadMethod == 'request'">
                    <button class="btn btn-sm btn-success">Request</button>
                  </div>
                </div>
              </div>
            </div>

           
          </div>

          <!-- OR Separator -->
          <div class="or-separator">
            <div class="line"></div>
            <div class="or-text">OR</div>
            <div class="line"></div>
          </div>

          <!-- Upload Method: Drag and Drop -->
          <div class="upload-option">
            <label class="d-flex align-items-center">
              <input type="radio" name="uploadMethod" value="upload" [(ngModel)]="selectedUploadMethod" class="mr-05" />
              <strong> Drag & Drop Upload</strong>
            </label>

            <div [class.disabled-section]="selectedUploadMethod !== 'upload'" class="mt-2">
              <div class="upload-box"
                   (drop)="onDrop($event)"
                   (dragover)="onDragOver($event)"
                   (dragleave)="onDragLeave($event)"
                   [class.dragover]="isDragging"
                   [class.disabled-box]="selectedUploadMethod !== 'upload'">

                <div class="upload-content">
                  <i class="fa fa-upload upload-icon"></i>
                  <p>Drag and Drop files here</p>
                  <p>or</p>
                  <label for="fileInput" class="browse-link">Browse files</label>
                  <input type="file" id="fileInput" hidden (change)="onFilesSelected($event)" multiple [disabled]="selectedUploadMethod !== 'upload'" />
                </div>

                <div class="upload-preview mt-2" *ngIf="uploadedFiles.length > 0">
                  <p *ngFor="let file of uploadedFiles">{{ file.name }}</p>
                </div>
              </div>
            </div>
          </div>



        </div>

        <div class="livefoot row no-gutters">
          <div class="col">
            <button type="submit" class="btn btn-success float-right mr-1"
                    [disabled]="!selectedMediaType">Upload</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>



<div id="Share_Case" tabindex="-1" class="modal fade right" style="z-index: 1;" aria-modal="true" role="dialog">
  <div class="modal-dialog no-m" style="width: 27%;">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">Share Case</h6>
        <button type="button" data-dismiss="modal" aria-label="Close" class="close">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <form novalidate="" name="createreqform" class="">
        <div class="modal-body card-scroll">
          <div class="form-group">
            <label> Fleet</label>
            <select class="form-control ">
              <option value="1" class="">Select</option>
            </select>
          </div>
          <div class="form-group">
            <label>Category</label>
            <select class="form-control ">
              <option value="1" class="">Select</option>
            </select>
          </div>
          <div class="form-group">
            <label>Expiry Date</label>
            <select class="form-control ">
              <option value="1" class="">Select</option>
            </select>
          </div>
          <div class="form-group">
            <label>VRN</label>
            <input placeholder="" type="text" required="" class="form-control ">
          </div>

          <div class="form-group">
            <label>File Download</label>
            <label class="switch">
              <input type="checkbox">
              <span class="slider round"></span>
            </label>


          </div>

          <div class="form-group">
            <label>Read Only</label>
            <label class="switch">
              <input type="checkbox">
              <span class="slider round"></span>
            </label>


          </div>
        </div>
        <div class="livefoot row no-gutters">
          <div class="col">
            <button type="submit" class="btn btn-success float-right mr-1" disabled="">Share</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<!--
<div id="filters" tabindex="-1" class="modal fade right" style="z-index: 1;" aria-modal="true" role="dialog">
  <div class="modal-dialog no-m" style="width: 27%;">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">Filters</h6>
        <button type="button" data-dismiss="modal" aria-label="Close" class="close">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <form novalidate="" name="createreqform" class="">
        <div class="modal-body card-scroll">
          <div class="form-group">
            <label>Empty</label>
            <input placeholder="" type="text" required="" class="form-control ">
          </div>
        </div>
        <div class="livefoot row no-gutters">
          <div class="col">
            <button type="submit" class="btn btn-success float-right mr-1" disabled="">Apply</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>-->
</div>
